<template>
  <div class="page-wrapper storybook-cnc-badge-dot">
    <StorybookTemplate title="CncBadgeDot" pathComponent="/shared/elements/global/v1/CncBadgeDot.vue" :propList="propList" :form.sync="form">
      <CncBadgeDot v-bind="form">{{ form.name }}</CncBadgeDot>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      propList: [
        { name: 'isShow', type: 'boolean', param: 'isShow' },
        { name: 'outline', type: 'boolean', param: 'outline' },
        {
          name: 'size',
          type: 'select',
          param: 'size',
          default: 'dot',
          option: [
            { label: 'dot', name: 'Dot' },
            { label: 'small-dot', name: 'Small dot' }
          ]
        }
      ],

      form: {
        isShow: true,
        outline: false,
        size: 'dot'
      }
    }
  }
}
</script>
